import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.hr(() => [tw`border-t border-solid border-silver-lighten-15`]);
